const OFFICIAL_IDENTITIES = [
  'official.sep-shinkai',
  'relayer_pub_01.sep-shinkai',
  'shinkai_delegate.sep-shinkai',
  'libp2p_relayer.sep-shinkai',
];
export const isOfficialIdentity = (identity: string): boolean => {
  return OFFICIAL_IDENTITIES.includes(identity);
};
